import { Link } from "react-router-dom";

export default function CartItem({
  title,
  image,
  price,
  quantity,
  setQuantity,
  onRemove,
  type,
}) {
  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  return (
    <li className="list-group-item py-3 px-0 border-top">
      <div className="row align-items-center g-3">
        {/* Product Image */}
        <div className="col-3 col-sm-2">
          <img
            src={image}
            alt={title}
            className="img-fluid rounded"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Product Details */}
        <div className="col-5 col-sm-5">
        {type != "General" 
          ?<h6 className="mb-1 cart-product-title">{title} ({type})</h6>
          :<h6 className="mb-1 cart-product-title">{title}</h6>
        }
          <div className="mt-1 small">
            <Link to="#" onClick={onRemove} className="text-decoration-none">
              <i className="bi bi-trash text-danger me-1"></i>
              <span className="text-muted">Remove</span>
            </Link>
          </div>
        </div>

        {/* Quantity */}
        <div className="col-4 col-sm-3">
          <div className="input-group">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={decreaseQuantity}
            >
              -
            </button>

            <input
              type="text"
              value={quantity}
              readOnly
              className="form-control text-center fw-bold"
              style={{
                color: "#000",
                backgroundColor: "#fff",
              }}
            />

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={increaseQuantity}
            >
              +
            </button>
          </div>
        </div>

        {/* Price */}
        <div className="col-12 col-sm-2 text-sm-end">
          <span className="fw-bold text-dark">
            ₹{(price * quantity).toFixed(2)}
          </span>
        </div>
      </div>
    </li>
  );
}
